import { render } from "./TopicList.vue?vue&type=template&id=517b6e1a"
import script from "./TopicList.vue?vue&type=script&lang=js"
export * from "./TopicList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mobitel/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__